import { RowExportTypePdf } from "types"
import { TaxCodeType } from "../types"
import { PdfTemplate } from "components"

export function Pdf(props: {
    dataList: TaxCodeType[]
}) {
    const columns = [
        { header: "NO", key: "no", width: 5 },
        { header: "TAX CODE", key: "tax_code", width: 10 },
        { header: "NAME", key: "name", width: 10 },
        { header: "TYPE", key: "type", width: 15 },
        { header: "RATE", key: "rate", width: 10 },
        { header: "COA COLLECT", key: "coa_collect", width: 15 },
        { header: "COA PAID", key: "coa_paid", width: 15 },
        { header: "NOTE", key: "note", width: 20 },
    ]

    const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => (
        { 
            no: index + 1, 
            tax_code: item.tax_code, 
            name: item.tax_name, 
            type: item.type_tax_name, 
            rate: item.rate, 
            coa_collect: `${item.coa_collect_coa_code} - ${item.coa_collect_coa_name}`,
            coa_paid: `${item.coa_paid_grp_code} - ${item.coa_paid_coa_code} - ${item.coa_paid_coa_name}`, 
            note: item.note 
        }
    ))

    return (
        <PdfTemplate data={dataMap} column={columns} title="Tax Code" />
    )
}